import * as React from "react";
import "./filters.scss";
import Input from "../../../hiberUiKit/src/atoms/Input/Input";
import {none, option, Option} from "ts-option";
import FilterButton from "./button/FilterButton";
import DropDownWrapper from "../../../hiberUiKit/src/molecules/DropDownWrapper/DropDownWrapper";
import FilterButtons from "./FilterButtons";
import Filter, {FilterTypeEnum} from "../../../model/workspace/Filter";
import OptionUtils from "../../../utils/OptionUtils";
import Checkbox from "../../../hiberUiKit/src/atoms/Checkbox/Checkbox";

interface IProps {
	filter: Filter
	onChange: (filter: Filter) => void;
	onRemove: (refreshData: boolean) => void;
	isFilterConfigVisible?: boolean;
	negationDisable?: boolean
}

interface IState {
	/**
	 * Filter text
	 */
	text: Option<string>
	/**
	 * Indicates if filter config is visible
	 */
	isFilterConfigVisible: boolean
	/**
	 * Indicates if negation checkbox is selected
	 */
	isNegated: boolean
}

export default class StringFilter extends React.Component<IProps, IState> {

	constructor(props: IProps) {
		super(props);
		this.state = {
			text: this.props.filter.values as Option<string>,
			isFilterConfigVisible: props.isFilterConfigVisible,
			isNegated: props.filter.isNegated()
		};

		this.onCancel = this.onCancel.bind(this);
		this.onDone = this.onDone.bind(this);
	}

	render() {
		return (
			<div>
				<FilterButton filterName={this.props.filter.columnDefinition.label}
							  onRemove={() => this.props.onRemove(true)}
							  onClick={() => this.setState({isFilterConfigVisible: true})}
							  filterValue={(this.props.filter.values as Option<string>).orNull}
							  isDisabled={this.state.isFilterConfigVisible}
							  isNegated={this.props.filter.isNegated()}/>
				{
					this.state.isFilterConfigVisible &&
					<DropDownWrapper width={"auto"} onOutsideClick={this.onCancel}>
						<div className={"c-filter-string-input-container"}>
							<Input type={"text"}
								   placeholder={"Contains..."}
								   value={this.state.text.getOrElse("")}
								   onChange={t => this.setState(
									   {text: t.target.value.trim().length ? option(t.target.value) : none})}
								   focus/>
						</div>
						{!this.props.negationDisable && <div className={"c-filter-string-negation-checkbox"}>
							<Checkbox checked={this.state.isNegated}
									  label={"Is not"}
									  styles={{color: "#112363"}}
									  onChange={(value) => this.setState({isNegated: value})}/>
						</div>}
						<FilterButtons onCancel={this.onCancel}
									   onDone={this.onDone}
									   disabled={this.state.text.map(t => t.trim().length == 0).getOrElse(true)}/>
					</DropDownWrapper>
				}
			</div>
		);
	}

	onCancel() {
		this.setState({isFilterConfigVisible: false},
			() => this.props.filter.values.isEmpty && this.props.onRemove(false));
	}

	onDone() {
		const filterType = this.state.isNegated ? FilterTypeEnum.NotEqual : FilterTypeEnum.Equal;
		this.setState({isFilterConfigVisible: false},
			() => this.isFilterChanged(filterType)
				&& this.props.onChange(this.props.filter.copy({values: this.state.text.map(t => t.trim()), type: filterType})))
	}

	isFilterChanged(filterType: FilterTypeEnum) {
		return !OptionUtils.isTheSame(this.props.filter.values, this.state.text) || this.props.filter.type !== filterType
	}
}
